import clsx from "clsx";
import styles from "./index.module.scss";

type StepDescProps = {
  className?: string;
  step: number;
  desc: string;
}

const StepDesc = (props: StepDescProps) => {
  const {
    className,
    step,
    desc,
  } = props;

  return (
    <div
      className={clsx(
        styles["step_desc"],
        className
      )}
    >
      <span 
        className={styles["step"]}
      >
        {step}
      </span>

      <span
        className={styles["desc"]}
      >
        {desc}
      </span>
    </div>
  )
}

export default StepDesc;